import './card.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { asLink } from './anchor';

const Card = forwardRef((props, ref) => {
  const className = classNames({
    card: true,
    [props.className]: props.className,
  });

  return (
    <div id={props.id} ref={ref} className={className} style={props.style}>
      {props.children}
    </div>
  );
});

Card.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

const Body = forwardRef((props, ref) => {
  const className = classNames({
    'card-body': true,
    [props.className]: props.className,
    [`card-body-compact-${props.compactBelow}`]: props.compactBelow,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Body.propTypes = {
  className: PropTypes.string,
  compactBelow: PropTypes.string,
  children: PropTypes.node,
};

const Header = forwardRef((props, ref) => {
  const className = classNames({
    'card-header': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Footer = forwardRef((props, ref) => {
  const className = classNames({
    'card-footer': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Footer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;

export default asLink(Card);
